export default __webpack_public_path__ + "static/media/icon-conj.87e4bbcf.svg";